import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Select from "react-select";
import { toast } from "react-toastify";
import { DatePicker } from "rsuite";
import {
  getBatch,
  getBowlingType,
  getPlayingExperience,
} from "../../../services/academicService";
import { publicPlayerEnqury } from "../../../services/publicService";
import { formatDate } from "../../../utils/helperFunction";

const EnquiryForm = ({ onSuccess }) => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [playingExperience, setPlayingExperience] = useState(null);
  const [selectedPlayingExperience, setSelectedPlayingExperience] =
    useState(null);
  const [batch, setBatch] = useState(null);
  const [selectedBatch, setSelectedBatch] = useState(null);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobileNumber: "",
    dob: null,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleDateChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [field]: "",
    }));
  };

  const validate = () => {
    let temp = {};

    if (!formData.name) temp.name = "Name is required";
    if (!formData.email) temp.email = "Email is required";
    if (!formData.mobileNumber) temp.mobileNumber = "Mobile is required";
    if (!formData.dob) temp.dob = "DOB is required";

    setErrors(temp);

    return Object.keys(temp).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate()) return;

    try {
      setLoading(true);
      const payload = {
        name: formData.name,
        email: formData.email,
        phone: formData.mobileNumber,
        dob: formData.dob ? formatDate(formData.dob) : null,
        tenantId: id,
        registration: false,
        experience: selectedPlayingExperience?.value || "",
        batch: selectedBatch?.value || "",
      };
      // API
      const res = await publicPlayerEnqury(payload);
      if (res) {
        onSuccess(res);
      }
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  async function fetchBatch() {
    try {
      const res = await getBatch();
      setBatch(res);
    } catch (error) {
      console.error("Error fetching coach skills:", error);
    }
  }

  async function fetchExperience() {
    try {
      const res = await getPlayingExperience();
      setPlayingExperience(res);
    } catch (error) {
      console.error("Error fetching coach skills:", error);
    }
  }

  useEffect(() => {
    fetchExperience();
    fetchBatch();
  }, []);

  return (
    <div className="player-card">
      <div className="player-card-header">
        <i className="fa fa-user-circle"></i>
        <span>Inquiry Form</span>
      </div>

      <div className="row">
        {/* Full Name */}
        <div className="col-lg-6">
          <div className="modern-group">
            <label>
              Full Name <span>*</span>
            </label>

            <div className="modern-input">
              <i className="fa fa-user"></i>

              <input
                type="text"
                name="name"
                placeholder="Enter your full name"
                value={formData.name}
                onChange={handleChange}
                className={errors.name ? "error-input" : ""}
              />
            </div>

            {errors.name && (
              <small className="text-danger">{errors.name}</small>
            )}
          </div>
        </div>

        {/* Mobile */}

        <div className="col-lg-6">
          <div className="modern-group">
            <label>
              Mobile Number <span>*</span>
            </label>

            <div className="modern-input">
              <i className="fa fa-phone"></i>

              <input
                type="number"
                name="mobileNumber"
                placeholder="Enter your mobile number"
                value={formData.mobileNumber}
                onChange={handleChange}
                className={errors.mobileNumber ? "error-input" : ""}
              />
            </div>

            {errors.mobileNumber && (
              <small className="text-danger">{errors.mobileNumber}</small>
            )}
          </div>
        </div>

        {/* Email */}

        <div className="col-lg-6">
          <div className="modern-group">
            <label>
              Email Address <span>*</span>
            </label>

            <div className="modern-input">
              <i className="fa fa-envelope"></i>

              <input
                type="email"
                name="email"
                placeholder="Enter your email"
                value={formData.email}
                onChange={handleChange}
                className={errors.email ? "error-input" : ""}
              />
            </div>

            {errors.email && (
              <small className="text-danger">{errors.email}</small>
            )}
          </div>
        </div>

        {/* DOB */}
        <div className="col-lg-6">
          <div className="modern-group">
            <label>
              Date of Birth <span>*</span>
            </label>

            <div className="modern-input">
              <DatePicker
                placeholder="DD / MM / YYYY"
                block
                value={formData.dob}
                onChange={(value) => handleDateChange("dob", value)}
                shouldDisableDate={(date) => date > new Date()}
                className="picker-suit hh"
              />
              <i className="fa fa-calendar"></i>
            </div>

            {errors.dob && <small className="text-danger">{errors.dob}</small>}
          </div>
        </div>

        <div className="col-lg-6">
          <div className="modern-group">
            <label>Playing Experience</label>

            <div className="modern-input">
              <i className="fa fa-futbol"></i>

              <Select
                isSearchable={false}
                className="modern-select"
                classNamePrefix="react-select"
                placeholder="Select Playing Experience"
                options={playingExperience?.map((item) => ({
                  value: item.key,
                  label: item.value,
                }))}
                value={selectedPlayingExperience}
                onChange={setSelectedPlayingExperience}
              />
            </div>
          </div>
        </div>

        <div className="col-lg-6">
          <div className="modern-group">
            <label>Preferred Batch</label>

            <div className="modern-input">
              <i className="fa fa-users"></i>

              <Select
                isSearchable={false}
                className="modern-select"
                classNamePrefix="react-select"
                placeholder="Select Preferred Batch"
                options={batch?.map((item) => ({
                  value: item.key,
                  label: item.value,
                }))}
                value={selectedBatch}
                onChange={setSelectedBatch}
              />
            </div>
          </div>
        </div>
      </div>

      <button
        className="continue-btn"
        onClick={handleSubmit}
        disabled={loading}
      >
        {loading ? "Processing..." : "Submit"}
      </button>

      <div className="secure-box">
        <i className="fa fa-shield-alt"></i>
        Your information is secure and will not be shared.
      </div>
    </div>
  );
};

export default EnquiryForm;
